export default __webpack_public_path__ + "static/media/26.b10fc07b.jpeg";